import { useEffect, useState } from 'react';

import { ACCEPT_TYPE_AUDIO, AcceptTypes } from './file-dropper.constants';

const useFileAudioDuration = ({
  source,
  accept,
}: {
  source?: string;
  accept?: AcceptTypes;
}) => {
  const [audioDuration, setAudioDuration] = useState<number | null>(null);

  useEffect(() => {
    if (source && accept?.includes(ACCEPT_TYPE_AUDIO)) {
      const audio = new Audio(source);

      audio.addEventListener('loadedmetadata', () => {
        setAudioDuration(audio.duration);
      });
    }
  }, [source, accept]);

  return {
    audioDuration,
    audioDurationLabel: !audioDuration
      ? '...'
      : audioDuration < 60
        ? `${Math.floor(audioDuration)} sec`
        : `${Math.floor(audioDuration / 60)} min`,
  };
};

export default useFileAudioDuration;
